import { useCallback } from "react";
import { useAttributeDeletionImpactLazyQuery } from "#graphql/supergraphHooks";

export interface UseAttributeDeletionImpactReturn {
  getDeletionImpact: (attributeId: string) => Promise<number | null>;
}

/**
 * Fetch the authoritative document count immediately before a destructive
 * confirmation. A null payload means the attribute is unknown or already
 * deleted; transport and GraphQL failures reject so the caller can offer retry.
 */
export const useAttributeDeletionImpact = (): UseAttributeDeletionImpactReturn => {
  const [runQuery] = useAttributeDeletionImpactLazyQuery({
    fetchPolicy: "no-cache",
  });

  const getDeletionImpact = useCallback(
    async (attributeId: string): Promise<number | null> => {
      const { data, error } = await runQuery({ variables: { id: attributeId } });
      if (error) throw error;
      return data?.attributeDeletionImpact?.documentCount ?? null;
    },
    [runQuery],
  );

  return { getDeletionImpact };
};
